import React, { Component } from 'react';
import PropTypes from "prop-types";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Time from "../../utils/Time";

export default class ReservationHistoryTableView extends Component {

    static propTypes = {
        reservations: PropTypes.arrayOf(PropTypes.shape({
            reservationRequestId: PropTypes.number.isRequired,
            advertisementId: PropTypes.number.isRequired,
            advertisementTitle: PropTypes.string.isRequired,
            spaceId: PropTypes.number.isRequired,
            spaceTitle: PropTypes.string.isRequired,
            statusId: PropTypes.number.isRequired,
            statusName: PropTypes.string.isRequired,
            startDate: PropTypes.string.isRequired,
            endDate: PropTypes.string.isRequired,
            created: PropTypes.number.isRequired,
            updated: PropTypes.number.isRequired,
            deleted: PropTypes.bool.isRequired,
            pricePerDay: PropTypes.number.isRequired,
            hasOverLappingRequests: PropTypes.bool.isRequired,
        }))
    };

    render() {

        if (this.props.reservations.length === 0) {
            return (
                <div className="text-muted text-center mt-5 mb-5">
                    You currently have no Reservation History.
                    <br/>
                    Here is where you would usually see the history
                    <br/>
                    of every request you've made
                    <br/>
                    or had made of you.
                </div>
            );
        }

        return (
            <table className="table">
                <thead className="thead-light">
                <tr>
                    <th scope="col">Space</th>
                    <th scope="col">Advertisement</th>
                    <th scope="col">Dates</th>
                    <th scope="col">Status</th>
                </tr>
                </thead>
                <tbody>
                {this.props.reservations.map((reservation) => {
                    return (
                        <tr key={"reservation_request_history_id_" + reservation.reservationRequestId}>
                            <th scope="row">
                                <button
                                    type="button"
                                    className="btn btn-link"
                                    onClick={(e) => this.handleSpaceClicked(reservation.spaceId)}>
                                    {reservation.spaceTitle}
                                </button>
                            </th>
                            <td>
                                <button
                                    type="button"
                                    className="btn btn-link"
                                    onClick={(e) => this.handleAdvertisementClicked(reservation.advertisementId)}>
                                    {reservation.advertisementTitle}
                                </button>
                            </td>
                            <td>{this._convertTimestampToStartAndEndString(reservation.startDate, reservation.endDate)}</td>
                            <td>{reservation.statusName.replace("_", " ")}</td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        )
    }

    handleSpaceClicked = (spaceId) => {
        EventPublisher.publish(UIInteractionEvents.HISTORY_SPACE_RESERVATION_SPACE_BUTTON_CLICKED, {spaceId: spaceId});
    };

    handleAdvertisementClicked = (advertisementId) => {
        EventPublisher.publish(UIInteractionEvents.HISTORY_SPACE_RESERVATION_ADVERTISEMENT_BUTTON_CLICKED, {advertisementId: advertisementId});
    };

    _convertTimestampToStartAndEndString(start, end) {
        return Time.parseDate(start).toLocaleDateString() + " to " + Time.parseDate(end).toLocaleDateString();
    }

}

